import React from "react";

import { Box, Menu, MenuItem, Typography } from "@mui/material";

import { grayLight, moovsBlue } from "design-system/colors";
import { CopyIcon, InfoIcon } from "design-system/icons";
import { NotificationVariable } from "types";

type SmartKeyMenuProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  notificationVariables: NotificationVariable[];
  onCopyToClipboard: (value: string) => Promise<void>;
  helpText?: string;
};

export function SmartKeyMenu(props: SmartKeyMenuProps): JSX.Element {
  const {
    anchorEl,
    open,
    onClose,
    notificationVariables,
    onCopyToClipboard,
    helpText,
  } = props;

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          minWidth: "250px",
          maxWidth: "3000px",
          boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.15)",
        },
        elevation: 0,
      }}
    >
      {helpText && (
        <Box px={2} mt={1}>
          <Box
            display="flex"
            bgcolor={grayLight}
            maxWidth="300px"
            p={1}
            borderRadius={1}
          >
            <Box ml={0.5} mr={1} mt={0.2}>
              <InfoIcon />
            </Box>
            <Box>
              <Typography variant="subtitle2">Add smart keys</Typography>
              <Typography variant="caption">{helpText}</Typography>
            </Box>
          </Box>
        </Box>
      )}

      <Box px={2} pt={1.5} pb={0.5}>
        <Typography variant="overline">AVAILABLE KEYS</Typography>
      </Box>
      {notificationVariables.map((smartKey) => (
        <MenuItem
          onClick={() => onCopyToClipboard(smartKey.key)}
          key={smartKey.key}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Box display="flex" flexDirection="column" gap={0.5}>
              <Typography variant="caption">{smartKey.description}</Typography>
              <Typography sx={{ fontWeight: 500, color: moovsBlue }}>
                {`{${smartKey.key}}`}
              </Typography>
            </Box>
            <Box ml={3}>
              <CopyIcon color={moovsBlue} />
            </Box>
          </Box>
        </MenuItem>
      ))}
    </Menu>
  );
}
